<template>
  <div class="content-container">
    <!-- Panel filtrów po lewej stronie (filtry archiwalnych pomiarów) -->
    <filters-archival-measurements />
    <!-- Główna część widoku: menu u góry oraz lista kontaktów -->
    <div class="content-wrap">
      <TopMenu />
      <ContactList />
    </div>
  </div>
</template>

<script>
// Importy niezbędnych komponentów
import TopMenu from "../components/TopMenu.vue";
import FiltersArchivalMeasurements from "../components/FiltersArchivalMeasurements.vue";
import ContactList from "../components/ContactList.vue";

export default {
  name: "ContactView", // Nazwa widoku (przydatne np. w debugowaniu)
  components: {
    TopMenu,
    ContactList,
    FiltersArchivalMeasurements,
  },
  methods: {
    // Metoda do czyszczenia (np. filtrów/wyborów); nieużywana w tym szablonie, ale zostawiona na przyszłość
    clear() {
      this.archival.clear();
      this.step = this.archival.step;
      this.isResult = this.archival.isResult;
    },
  },
};
</script>

<style scoped>
/* Spójne tło z BlackListView/WhiteListView. */
.content-container {
  background-color: #eef0ec;
}
</style>
